{
  "version": 1,
  "asset_id": "81ff79c3-dbd0-4ec4-a179-cc3f52948a79",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/81ff79c3-dbd0-4ec4-a179-cc3f52948a79/hiatal-type-2-sleeve-es-1448.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/81ff79c3-dbd0-4ec4-a179-cc3f52948a79/hiatal-type-2-sleeve-es-1448.webp",
  "original_filename": "hiatal-type-2-sleeve-es-1448.webp",
  "size": 86542,
  "content_type": "image/webp",
  "created_at": "2026-09-26T22:45:51Z"
}
